import axios from "../../axios/interceptor.js";
import Toast from "../../component/toastify/Index";

export const getForderungenLists = async (payload) => {
    try {
        const response = await axios.post('/customer/forderungen/get', payload)
        if (response?.data?.isSuccess) {
            return response.data
        } else {
            Toast(response?.data?.message, "error");
        }
    } catch (error) {
        Toast(error?.response?.data?.message ? error?.response?.data?.message : error?.message, "error");
    }
}

export const getByIdForderungen = async (id) => {
    try {
        const response = await axios.get(`/customer/forderungen/get/${id}`)
        if (response?.data?.isSuccess) {
            return response.data
        } else {
            Toast(response?.data?.message, "error");
        }
    } catch (error) {
        Toast(error?.response?.data?.message ? error?.response?.data?.message : error?.message, "error");
    }
}

export const deleteForderungen = async (id) => {
    try {
        const response = await axios.put(`/customer/forderungen/delete/${id}`)
        if (response?.data?.isSuccess) {
            return response.data
        } else {
            Toast(response?.data?.message, "error");
        }
    } catch (error) {
        Toast(error?.response?.data?.message ? error?.response?.data?.message : error?.message, "error");
    }
}


export const createForderungen = async (payload) => {
    try {
        const response = await axios.post('/customer/forderungen/create', payload)
        if (response?.data?.isSuccess) {
            return response.data
        } else {
            Toast(response?.data?.message, "error");
        }
    } catch (error) {
        Toast(error?.response?.data?.message ? error?.response?.data?.message : error?.message, "error");
    }
}


export const updateForderungen = async (payload) => {
    try {
        const response = await axios.put('/customer/forderungen/update', payload)
        if (response?.data?.isSuccess) {
            return response.data
        } else {
            Toast(response?.data?.message, "error");
        }
    } catch (error) {
        Toast(error?.response?.data?.message ? error?.response?.data?.message : error?.message, "error");
    }
}